module.exports = __webpack_public_path__ + "static/media/clinique_megival.3ed8458b.jpg";